module.exports = __webpack_public_path__ + "static/media/TrackandtraceActive.f6f113f1.svg";